import { IOfferSchema, IRoomInfoSchema, TNewObjectRoomType } from '@cian/api-models/offer-card/v1/get-offer-data';
import { FlatType, NewObjectRoomType } from '../../store/offer';
import { FOfferType, getOfferType, isFlat } from '../../utils/offer_type';

const roomTypes: TNewObjectRoomType[] = [
  NewObjectRoomType.Bed,
  NewObjectRoomType.Room,
  NewObjectRoomType.Share,
  NewObjectRoomType.Studio,
  NewObjectRoomType.OneRoom,
  NewObjectRoomType.TwoRoom,
  NewObjectRoomType.ThreeRoom,
  NewObjectRoomType.FourRoom,
  NewObjectRoomType.FiveRoom,
  NewObjectRoomType.Large,
  NewObjectRoomType.OpenPlan,
];

export function getRoomWeight(type: TNewObjectRoomType | null): number {
  if (!type) {
    return -1;
  }

  return roomTypes.indexOf(type);
}

export function mapOfferToRoomType(offer: IOfferSchema): TNewObjectRoomType | undefined {
  const offerType = getOfferType(offer);

  if (offerType === FOfferType.Bed) {
    return NewObjectRoomType.Bed;
  }

  if (offerType === FOfferType.Room) {
    return NewObjectRoomType.Room;
  }

  if (offerType === FOfferType.FlatShared) {
    return NewObjectRoomType.Share;
  }

  if (isFlat(offerType)) {
    if (offer.flatType === FlatType.Studio) {
      return NewObjectRoomType.Studio;
    }

    if (offer.flatType === FlatType.OpenPlan) {
      return NewObjectRoomType.OpenPlan;
    }

    // tslint:disable-next-line:switch-default
    switch (offer.roomsCount) {
      case 1:
        return NewObjectRoomType.OneRoom;
      case 2:
        return NewObjectRoomType.TwoRoom;
      case 3:
        return NewObjectRoomType.ThreeRoom;
      case 4:
        return NewObjectRoomType.FourRoom;
      case 5:
        return NewObjectRoomType.FiveRoom;
    }

    if (offer.roomsCount > 5) {
      return NewObjectRoomType.Large;
    }
  }

  return undefined;
}

export function getFilteredRoomsInfo(roomsInfo: IRoomInfoSchema[], offer: IOfferSchema) {
  const filteredRoomsInfo = roomsInfo.filter(Boolean);

  if (filteredRoomsInfo.length <= 3) {
    return filteredRoomsInfo;
  }

  const currentOfferRoomType = mapOfferToRoomType(offer);

  filteredRoomsInfo.sort((a, b) => (getRoomWeight(a.type) - getRoomWeight(b.type)));

  const index = filteredRoomsInfo.findIndex(({ type }) => type === currentOfferRoomType);

  if (index > 0) {
    const lastItem = filteredRoomsInfo[index + 1];

    return [
      filteredRoomsInfo[index - 1],
      filteredRoomsInfo[index],
      ...(lastItem ? [lastItem] : []),
    ];
  }

  return filteredRoomsInfo.slice(0, 3);
}
